module.exports = __webpack_public_path__ + "static/img/help_06intro_13.9118ba1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/stufdback/help_06intro_13.png
// module id = 726
// module chunks = 140